import React from 'react';
import { ManageReleasesCard } from './ManageReleasesCard';
import { ManageTemplatesCard } from './ManageTemplatesCard';

interface Props {
  releases: string[];
  selectedRelease: string | null;
  onSelect: (release: string) => void;
  // Optional extras forwarded into the "Manage releases" card, below the
  // action row — currently the Filters panel.
  children?: React.ReactNode;
}

// Composition for the left sidebar. Two stacked cards:
//   - "Manage releases" (release picker + Create/Copy/Delete + filters)
//   - "Manage templates" (collapsible — default-template refresh/restore)
export const ReleaseManagement = ({
  releases,
  selectedRelease,
  onSelect,
  children,
}: Props) => (
  <>
    <ManageReleasesCard
      releases={releases}
      selectedRelease={selectedRelease}
      onSelect={onSelect}
    >
      {children}
    </ManageReleasesCard>
    <ManageTemplatesCard />
  </>
);
